// import { AppleIcon, InsuranceIcon } from "../icons";
import { Toasts } from "./toasts";

const el = {
  root: document.querySelector('.styleguide'),
  toastButton: document.querySelector<HTMLButtonElement>('.styleguide__toast-button'),
};

export const StyleGuide = {

  init: () => {
    if (!el.root) return
    if (el.toastButton) {
      el.toastButton.addEventListener('click', StyleGuide.onToastButtonClick)
    }
  },

  onToastButtonClick: () => {
    Toasts.addToast({
      title: 'Viðbótartryggingu bætt við körfu',
      text: 'iPhone 13 Pro 128GB Sierra Blue',
      image: '/assets/images/iphone.png',
    })
    // Toasts.addToast({
    //   title: 'Viðbótartryggingu bætt við körfu',
    //   text: 'iPhone 13 Pro 128GB Sierra Blue',
    //   icon: InsuranceIcon()
    // })
  }
};
